<div class="dev-login-overlay" *ngIf="visible">
  <div class="dev-login-card">
    <div class="dev-login-logo">
      <img src="assets/images/logo/deckpro_logo.png" alt="DeckPro" onerror="this.style.display='none'">
      <h2>Sign In Required</h2>
      <p>This environment requires authentication to access.</p>
    </div>

    <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
      <div *ngIf="errorMessage" class="dev-login-error">
        {{ errorMessage }}
      </div>

      <div class="dev-login-field">
        <label for="devEmail">Email</label>
        <input
          id="devEmail"
          type="email"
          [(ngModel)]="email"
          name="email"
          placeholder="Enter your email"
          required
          autocomplete="email"
        />
      </div>

      <div class="dev-login-field">
        <label for="devPassword">Password</label>
        <div class="dev-login-password-wrap">
          <input
            id="devPassword"
            [type]="showPassword ? 'text' : 'password'"
            [(ngModel)]="password"
            name="password"
            placeholder="Enter your password"
            required
            autocomplete="current-password"
          />
          <button type="button" class="dev-login-eye" (click)="togglePasswordVisibility()">
            <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
        </div>
      </div>

      <button type="submit" class="dev-login-btn" [disabled]="!loginForm.valid">
        Sign In
      </button>
    </form>
  </div>
</div>
